import { createElementIdSlice } from '../utils/action/createElementSlice';
export const TextState = createElementIdSlice({
    elementName: 'text',
    initialState: {},
    reducers: {
        notifyInteraction: (state, _action) => state,
        notifyDoubleClick: (state) => state,
    },
});
